<template>
  <div class="login_container">
    <h2 class="label_login">登录</h2>
    <el-form
      ref="login_form"
      label-position="right"
      :rules="rules"
      :model="form"
    >
      <el-form-item prop="regName" label="">
        <el-input
          placeholder="用户名"
          prefix-icon="el-icon-user"
          :maxlength="30"
          clearable
          v-model="form.regName"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password" label="">
        <el-input
          placeholder="密码"
          prefix-icon="el-icon-key"
          clearable
          :maxlength="20"
          show-password
          @keyup.13.native="handlerKeyUp"
          v-model="form.password"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="onSubmit"> 登录 </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { loginVt, login } from "@/api/login";
import { jsEncrypt } from "@/utils";
import { userInfo } from "@/api/user";
// import md5 from 'js-md5'
export default {
  name: "Login",
  data() {
    return {
      key: "",
      rsa: "",
      form: {
        regName: "",
        password: "",
        userType: 0, // TODO: 暂时写死   0 --- Saas平台  1 --- '集团用户'
      },
      rules: {
        regName: [
          {
            required: true,
            message: "请输入帐号",
            trigger: "blur",
          },
          {
            min: 4,
            max: 30,
            message: "帐号长度在 4 到 30 个字符",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: "密码长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    onSubmit() {
      this.$refs.login_form.validate((valid) => {
        if (valid) {
          /* this.rsa = this.encryptPublic(
            '6589491516546',
            ' MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC8ygSXIVsIN1m5wiOOV5wd7MaAjL5iouJ25cpuHAZZlCtyRHS2tINTuWc+dHQF7fY6vGILOgP/U+e6hTa8nCBwiEF1f590nzuTLo6DIeHypQbxAT5tpswZ6ZpxTjNy29OfXvoU7OZV/xf2gw780tLxCNCW49IYSv0LPyJgKGJTnQIDAQAB'
          )
          console.log('this.rsa', this.rsa)
          this.decryptPrivate(
            this.rsa
            ,
            'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBALzKBJchWwg3WbnCI45XnB3sxoCMvmKi4nblym4cBlmUK3JEdLa0g1O5Zz50dAXt9jq8Ygs6A/9T57qFNrycIHCIQXV/n3SfO5MujoMh4fKlBvEBPm2mzBnpmnFOM3Lb059e+hTs5lX/F/aDDvzS0vEI0Jbj0hhK/Qs/ImAoYlOdAgMBAAECgYANrcOEYcXTRBNruq3R1/Y3UtsVIF2BDxVCkSbIMJ6jKfG171DXlh+31sSsyUpIzbOcEN83ugXlH6K4KIPNSbCt5s0G/uAaZHjEDRtN4EQKmWnzz7RdvPkqHaoOl5uPewNEHOCM/f/bJko6zjptmqSo5KmWehXKMtQsvCSnAJ3trwJBAN8UrgXlzzxdTqAl/+0pM7md8Y1BUxh4o8YVC3G1aTaYq+LzkVvE+FDQWU7+wViuvFFA+xT7j4Rm6Oyj2AK1fF8CQQDYpecnZYd88/dOvwq1mih7MKXexz+8nVDXTrewwvxu37nDo25ge6/japIZjZz5Ai+GLcc5fPHQ/44aBxwDOrGDAkBf7o2znZMT+3AvcIfxXhGPVfulah0o3eBX837bZE8dmmP4khPFahv67M4rKWTOFT6IlrAi4tdh8bti4EapS5BzAkBocQJQoceBW3N7yOl2xsyBJuCv10pIuWZBhbdURYvAP6akQ+NwK/CNJ9Eq9HQaLw2OF/+VHUDOSoTM02STwfXVAkAyQH3XbN0CEoO1Ub5zKw2qpmZ0D+df2RtWrQoW/Ydjr6U4V0IGbqt9v/PuNvtYPVGNPOvhrQStW6jggJMD2gKx'
          ) */

          const params = {
            regName: this.form.regName,
          };
          loginVt(params)
            .then((res) => {
              this.key = res.data.data;
              this.rsa = jsEncrypt.encryptPublic(this.form.password, this.key); // rsa根据公钥加密
            })
            .then(() => {
              const aparams = {
                regName: this.form.regName,
                password: this.rsa,
                userType: this.form.userType,
              };
              login(aparams)
                .then((res) => {
                  if (res.data.code === 0 || res.data.code === 30) {
                    // this.$message({
                    //   message: '登录成功',
                    //   type: 'success'
                    // })
                    localStorage.setItem("userName", this.form.regName);
                  }
                })
                .then(() => {
                  userInfo().then((res) => {
                    // TODO: 这是异步操作
                    this.$store.commit("SET_USERINFOS", res.data.data);
                  });
                  this.$router.push("/home");
                })
                .catch((err) => {
                  console.log("err===", err);
                });
            });
        } else {
          this.$message.error("登录失败");
          return false;
        }
      });
    },
    // 13键
    handlerKeyUp(e) {
      if (e.keyCode === 13) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login_container {
  width: 100%;
  height: 100%;
  background-color: #687e99;
  overflow: hidden;

  .label_login {
    color: white;
    margin-top: 200px;
    text-align: center;
  }
}

.el-form {
  border: 1px solid white;
  border-radius: 10px;
  padding: 30px 30px 0 30px;
  width: 300px;
  margin: 20px auto;
  text-align: center;

  .el-button {
    width: 100%;
  }
}
</style>
